import { TemplateFormEditor } from "src/cases/templates/common/TemplateFormEditor";

export const CaseActionFormEditor: React.FC<{
  actionIndex: number;
}> = ({ actionIndex }) => {
  return <TemplateFormEditor itemIndex={actionIndex} itemType="action" />;
};
